module.exports = __webpack_public_path__ + "img/bg-m.119884d1.svg";